import { SupportTicketDetailPage, SupportTicketListPage } from "@Elements";
import { DashboardBaseRoute } from "./Dashboard.route";
import { createRoute, redirect } from "@tanstack/react-router";

export const SupportTicketBaseRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/support-ticket",
  staticData: {
    TITLE: "Destek",
    IS_BASE_ROUTE: true,
  },
  beforeLoad: (route) => {
    if (route.location.pathname === SupportTicketBaseRoute.fullPath)
      throw redirect({
        to: SupportTicketListRoute.fullPath,
      });
  },
});
export const SupportTicketListRoute = createRoute({
  getParentRoute: () => SupportTicketBaseRoute,
  path: "/list",
  component: SupportTicketListPage,
  staticData: {
    TITLE: "Destek Listesi",
  },
});

export const SupportTicketDetailRoute = createRoute({
  getParentRoute: () => SupportTicketBaseRoute,
  path: "/detail/$id",
  component: SupportTicketDetailPage,
  staticData: {
    TITLE: "Destek Detayı",
    PARENT_ROUTE: SupportTicketListRoute,
  },
});

export const SupportTicketRouteTree = SupportTicketBaseRoute.addChildren([
  SupportTicketListRoute,
  SupportTicketDetailRoute,
]);
